import axios from "axios";
import { BASE_URL } from "../BaseUrl.js";

axios.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem("babiSolde_api");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      config.headers.Authorization = null;
    }

    return config;
  },
  function (error) {
    console.log("AN ERROR REQUEST", error);
  }
);

//liste des Boutiques
export const loginAuthUser = async (values) => {
  return await axios.post(`${BASE_URL}/auth/login`, values);
};

//   export const changePasswordAdmin = async (values) => {
//     return await axios.post(BASE_URL("auth/changermotdepasse"), values);
//   };

export const ForgetPasswordUser = async (values) => {
  return await axios.post(
    `${BASE_URL}/auth/forgot-password`,
    values
  );
};

//   export const recupererProfilUtilisateurConnecte = async (userID) => {
//     return await axios.get(BASE_URL(`metier/recuperer-profil/${userID}`), {});
//   };
